import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileType", "variantContainer"]

  connect() {
    this.updateRequiredIndicators()
    this.checkEmbeddingAvailability()
  }

  fileTypeChanged() {
    this.updateRequiredIndicators()
    this.checkEmbeddingAvailability()
  }

  updateRequiredIndicators() {
    const selectedFileTypes = this.getSelectedFileTypes()

    // 모든 variant container를 찾아서 업데이트
    const variantContainers = document.querySelectorAll('[data-weight]')

    variantContainers.forEach(container => {
      // 각 파일 타입별로 필수 표시 업데이트
      const fileTypeBoxes = container.querySelectorAll('[data-file-type]')

      fileTypeBoxes.forEach(box => {
        const fileType = box.getAttribute('data-file-type')
        const requiredIndicator = box.querySelector('.required-indicator')
        const checkIcon = box.querySelector('.text-green-500')

        // 이미 업로드된 파일이 있으면 필수 표시 숨김
        if (checkIcon) {
          if (requiredIndicator) {
            requiredIndicator.style.display = 'none'
          }
        } else {
          // 선택된 file_types에 포함되어 있으면 필수 표시
          if (selectedFileTypes.includes(fileType)) {
            if (requiredIndicator) {
              requiredIndicator.style.display = 'inline'
            } else {
              // 필수 표시가 없으면 추가
              const titleElement = box.querySelector('.variant-title')
              if (titleElement && !checkIcon) {
                const newIndicator = document.createElement('span')
                newIndicator.className = 'required-indicator text-xs text-red-500'
                newIndicator.textContent = '* 필수'
                titleElement.appendChild(newIndicator)
              }
            }
          } else {
            // 선택되지 않은 파일 타입은 필수 표시 숨김
            if (requiredIndicator) {
              requiredIndicator.style.display = 'none'
            }
          }
        }
      })
    })
  }

  getSelectedFileTypes() {
    const checkboxes = this.fileTypeTargets
    return checkboxes
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  checkEmbeddingAvailability() {
    const woffChecked = this.isFileTypeChecked('woff')
    const woff2Checked = this.isFileTypeChecked('woff2')
    const hasWebFontFormat = woffChecked || woff2Checked

    const embeddingScope = this.findEmbeddingScopeElement()
    if (!embeddingScope) return

    // 컨트롤 영역 찾기
    const controlsContainer = embeddingScope.querySelector('[data-embedding-controls]')

    if (!hasWebFontFormat) {
      // WOFF/WOFF2 없음 -> UI 숨김
      if (controlsContainer) {
        controlsContainer.classList.add("hidden")
      }

      // 경고 메시지 표시
      this.showEmbeddingWarning(embeddingScope)
    } else {
      // WOFF/WOFF2 있음 -> UI 표시
      if (controlsContainer) {
        controlsContainer.classList.remove("hidden")
      }

      // 경고 메시지 숨김
      this.hideEmbeddingWarning(embeddingScope)
    }
  }

  isFileTypeChecked(fileType) {
    return Array.from(this.fileTypeTargets).some(
      checkbox => checkbox.value === fileType && checkbox.checked
    )
  }

  findEmbeddingScopeElement() {
    // license_scope.code가 'embedding'인 설정 찾기
    const allScopes = document.querySelectorAll('[data-controller~="font-upload--license-scope"]')
    return Array.from(allScopes).find(scope => {
      const licenseCode = scope.getAttribute('data-license-scope-code')
      return licenseCode === 'embedding'
    })
  }

  showEmbeddingWarning(scopeElement) {
    // 이미 경고가 있으면 중복 생성 방지
    if (scopeElement.querySelector('.embedding-auto-disabled-warning')) return

    const warning = document.createElement('div')
    warning.className = 'embedding-auto-disabled-warning text-xs text-orange-600 dark:text-orange-400 mt-2'
    warning.textContent = '※ WOFF 또는 WOFF2 파일이 필요합니다'

    scopeElement.appendChild(warning)
  }

  hideEmbeddingWarning(scopeElement) {
    const warning = scopeElement.querySelector('.embedding-auto-disabled-warning')
    if (warning) warning.remove()
  }
}